/**
 * Fireloop landing page — interactions
 * Header scroll state, FAQ accordion, scroll reveal
 */
(function () {
  'use strict';

  var ROOT = document.querySelector('.fireloop-page');
  if (!ROOT) return;

  // -------------------------------------------------------------------------
  // Sticky header: transparent → solid on scroll
  // -------------------------------------------------------------------------
  var header = ROOT.querySelector('.fireloop-header');
  if (header) {
    var scrollY = 0;
    function updateHeader() {
      scrollY = window.scrollY || window.pageYOffset;
      if (scrollY > 60) {
        header.classList.add('fireloop-header--solid');
      } else {
        header.classList.remove('fireloop-header--solid');
      }
    }
    updateHeader();
    window.addEventListener('scroll', function () {
      requestAnimationFrame(updateHeader);
    }, { passive: true });
  }

  // -------------------------------------------------------------------------
  // Mobile drawer
  // -------------------------------------------------------------------------
  var menuBtn = ROOT.querySelector('.fireloop-header__menu-btn');
  var drawer = ROOT.querySelector('.fireloop-header__drawer');
  var overlay = ROOT.querySelector('.fireloop-header__drawer-overlay');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer();
      else openDrawer();
    });
  }
  var closeBtn = ROOT.querySelector('.fireloop-header__drawer-close');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });
  }

  // -------------------------------------------------------------------------
  // FAQ accordion
  // -------------------------------------------------------------------------
  ROOT.querySelectorAll('.fireloop-faq__item').forEach(function (item) {
    var btn = item.querySelector('.fireloop-faq__q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      ROOT.querySelectorAll('.fireloop-faq__item').forEach(function (other) {
        other.classList.remove('is-open');
        var otherBtn = other.querySelector('.fireloop-faq__q');
        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // -------------------------------------------------------------------------
  // Scroll reveal
  // -------------------------------------------------------------------------
  var revealEls = ROOT.querySelectorAll('.fireloop-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0.1 }
    );
    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }
})();
